export default {
    topics: [
        {
            title: ' Example ',
            href: 'p-32.html',
            attributes: { 'data-id': 'p-32' },
            menu: { hasChildren: false },
            tocID: 'p-32-d66e7556',
            topics: [],
        },
        {
            title: 'Syntax',
            href: 'p-34.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7564',
            next: 'tocId-d66e7564',
        },
        {
            title: 'Objects',
            href: 'c-Cookie.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7589',
            next: 'tocId-d66e7589',
        },
    ],
};

